<template>
  <div>
    <el-dialog :visible.sync="visible" width="400px" :center="false">
      <div slot="title" class="title-container">
        <span>Select Send Ranges</span>
      </div>
      <el-form ref="form-date" label-width="120px">
        <el-form-item label="Sheets Range">
          <el-select
            v-model="sheetRange"
            multiple
            placeholder="Multiple Select"
            style="width: 200px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Date Range">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="From"
            end-placeholder="To"
            format="dd MMM yyyy"
            value-format="yyyy-MM-dd"
            size="mini"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleSend">Send</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { batchSendXero } from '../api'

export default {
  name: 'DialogBatchSendXero',
  computed: {
    visible: {
      get () {
        return this.dialogVisible
      },
      set (val) {
        this.$emit('closed')
      }
    }
  },
  data () {
    return {
      dateRange: [],
      sheetRange: [],
      options: [
        {
          value: '1',
          label: 'Invoices'
        },
        {
          value: '2',
          label: 'Credit Notes'
        },
        {
          value: '4',
          label: 'Bills'
        },
        {
          value: '5',
          label: 'Bill CreditNotes'
        }
      ]
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleSend () {
      const params = {
        dateRange: this.dateRange,
        sheets: this.sheetRange
      }
      await batchSendXero(params)
      this.$emit('closed')
      this.$message({
        message: 'Preparing for Sending, please CHECK in sheet list pages',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
